import { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordReset } from '@paulownia/shared/lib/auth';
import { Button } from '@paulownia/shared/components/ui/button';
import { Input } from '@paulownia/shared/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@paulownia/shared/components/ui/card';
import { toast } from 'sonner';

export const ResetPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleResetPassword = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            await sendPasswordReset(email);
            setSent(true);
            toast.success('Email de réinitialisation envoyé');
        } catch (error) {
            console.error('Reset password error:', error);
            const authError = error as { code?: string };

            let errorMessage = 'Erreur lors de l\'envoi de l\'email';

            if (authError.code === 'auth/user-not-found') {
                errorMessage = 'Aucun compte associé à cet email';
            } else if (authError.code === 'auth/invalid-email') {
                errorMessage = 'Email invalide';
            } else if (authError.code === 'auth/too-many-requests') {
                errorMessage = 'Trop de tentatives. Réessayez plus tard';
            } else if (authError.code === 'auth/network-request-failed') {
                errorMessage = 'Erreur réseau. Vérifiez votre connexion';
            }

            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <Card className="w-full max-w-md">
                <CardHeader>
                    <CardTitle className="text-2xl text-center">Réinitialiser le mot de passe</CardTitle>
                </CardHeader>
                <CardContent>
                    {sent ? (
                        <div className="space-y-4 text-center">
                            <p className="text-sm text-muted-foreground">
                                Un email de réinitialisation a été envoyé à <strong>{email}</strong>.
                                Vérifiez votre boîte de réception et suivez les instructions.
                            </p>
                            <Link to="/login">
                                <Button variant="outline" className="w-full">
                                    Retour à la connexion
                                </Button>
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={handleResetPassword} className="space-y-4">
                            <p className="text-sm text-muted-foreground">
                                Entrez votre adresse email pour recevoir un lien de réinitialisation de mot de passe.
                            </p>
                            <div className="space-y-2">
                                <label htmlFor="email-reset" className="text-sm font-medium">
                                    Email
                                </label>
                                <Input
                                    id="email-reset"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="nom@exemple.com"
                                    required
                                    disabled={loading}
                                />
                            </div>
                            <Button type="submit" className="w-full" disabled={loading}>
                                {loading ? 'Envoi...' : 'Envoyer le lien de réinitialisation'}
                            </Button>
                            <div className="text-center">
                                <Link to="/login" className="text-sm text-muted-foreground hover:underline">
                                    Retour à la connexion
                                </Link>
                            </div>
                        </form>
                    )}
                </CardContent>
            </Card>
        </div>
    );
};
